import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65fc1eed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-ext" }
const _hoisted_2 = { class: "links" }
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = { class: "spacer-learn-more" }

import LaunchBtn from '@/components/Buttons/LaunchBtn.vue'
import LearnMoreBtn from '@/components/Buttons/LearnMoreBtn.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(LaunchBtn),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(LearnMoreBtn)
        ])
      ])
    ])
  ]))
}
}

})